import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SubHeaderComponent } from '../../components/sub-header/sub-header.component';
import { TransferListComponent } from '../../components/organisation-management/transfer_list/transfer_list.component';
import { StructureListComponent } from '../../components/organisation-management/structure_list/structure_list.component';
import { EmailListComponent } from '../../components/organisation-management/email_list/email_list.component';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'importer-organisation-management',
  templateUrl: './organisation_management.component.html',
  styleUrls: ['./organisation_management.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SubHeaderComponent, V2ButtonComponent, TransferListComponent, StructureListComponent, EmailListComponent]
})
export class OrganisationManagementComponent {
  private readonly router = inject(Router);

  openList: 'transfer' | 'structure' | 'email';

  constructor() {
    this.openList = 'transfer';
  }

  openTransferListPage() {
    this.openList = 'transfer';
    this.router.navigate([]);
  }
  openStructureListPage() {
    this.openList = 'structure';
    this.router.navigate([]);
  }
  openEmailListPage() {
    this.openList = 'email';
    this.router.navigate([]);
  }
}
